// src/app/userConfigSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/api';

export const fetchUserConfig = createAsyncThunk(
  'userconfig/fetchUserConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/auth/me');
      return response;
    } catch (error) {
      return rejectWithValue(error.response || 'Unknown error');
    }
  }
);

const initialState = {};

const userConfigSlice = createSlice({
  name: 'userconfig',
  initialState,
  reducers: {
    setConfig: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateConfigKey: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    clearConfig: () => ({}), // <- for clearing data
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserConfig.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
  },
});

export const { setConfig, updateConfigKey, clearConfig } = userConfigSlice.actions;
export default userConfigSlice.reducer;
